import React, { useEffect } from 'react'
import { incrementMetric } from 'marketing-site/lib/frontendMetrics'

export const HeadPart: React.FC<{ nonce: string }> = ({ nonce }) => (
  <script
    nonce={nonce}
    type="text/javascript"
    dangerouslySetInnerHTML={{
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;var n=d.querySelector('[nonce]');
      n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WB899HL');`,
    }}
  />
)

export const BodyPart: React.FC = () => {
  useEffect(() => {
    fetch('https://www.googletagmanager.com/gtm.js?id=GTM-WB899HL')
      .then(() =>
        incrementMetric('GtmJS.MarketingSite.googletagmanagerAdBlockCheck', { blocked: 'false' }),
      )
      .catch(() =>
        incrementMetric('GtmJS.MarketingSite.googletagmanagerAdBlockCheck', { blocked: 'true' }),
      )
    fetch('https://www.google-analytics.com/analytics.js', { mode: 'no-cors' })
      .then(() =>
        incrementMetric('GtmJS.MarketingSite.googleAnalyticsAdBlockCheck', { blocked: 'false' }),
      )
      .catch(() =>
        incrementMetric('GtmJS.MarketingSite.googleAnalyticsAdBlockCheck', { blocked: 'true' }),
      )
    fetch('https://munchkin.marketo.net/162/munchkin.js', { mode: 'no-cors' })
      .then(() =>
        incrementMetric('GtmJS.MarketingSite.marketoMunchkinAdBlockCheck', { blocked: 'false' }),
      )
      .catch(() =>
        incrementMetric('GtmJS.MarketingSite.marketoMunchkinAdBlockCheck', { blocked: 'true' }),
      )
    fetch('https://j.6sc.co/6si.min.js')
      .then(() => incrementMetric('GtmJS.MarketingSite.sixSenseAdBlockCheck', { blocked: 'false' }))
      .catch(() => incrementMetric('GtmJS.MarketingSite.sixSenseAdBlockCheck', { blocked: 'true' }))
  }, [])

  return (
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WB899HL"
        title="Google tag manager container"
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  )
}
